import React, { Suspense, lazy } from 'react'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter, push } from 'connected-react-router'
import Loader from 'components/Loader'
import IndexLayout from 'layouts'
import NotFoundPage from 'pages/system/404'
import Page403 from 'pages/system/403'
import Dashboard from 'pages/dashboard'
import { store } from './configureStore'

const routes = [
  {
    path: '/login',
    component: lazy(() => import('pages/login')),
  },
  {
    path: '/partners',
    component: lazy(() => import('pages/partners')),
  },
  {
    path: '/journal',
    component: lazy(() => import('pages/journal')),
  },
  {
    path: '/finance',
    component: lazy(() => import('pages/finance')),
  },
  {
    path: '/verification',
    component: lazy(() => import('pages/verification')),
    exact: true,
  },
  {
    path: '/create-goal',
    component: lazy(() => import('pages/create-goal')),
    exact: true,
  },
  {
    path: '/referral-links',
    component: lazy(() => import('pages/referral-links')),
    exact: true,
  },
  {
    path: '/news',
    component: lazy(() => import('pages/news')),
    exact: true,
  },
  {
    path: '/photobank',
    component: lazy(() => import('pages/photobank')),
    exact: true,
  },
  {
    path: '/videobank',
    component: lazy(() => import('pages/videobank')),
    exact: true,
  },
  {
    path: '/goal-report',
    component: lazy(() => import('pages/goal-report')),
  },
  {
    path: '/files',
    component: lazy(() => import('pages/files')),
  },
  {
    path: '/diagnostician-materials',
    component: lazy(() => import('pages/diagnostician-materials')),
  },
  {
    path: '/sales-report',
    component: lazy(() => import('pages/sales-report')),
  },
  {
    path: '/business-reputation-intro',
    component: lazy(() => import('pages/business-reputation-intro')),
  }
]

class Router extends React.Component {
  render() {
    const { history } = this.props
    return (
      <ConnectedRouter history={history}>
        <Suspense fallback={<Loader />}>
          <IndexLayout>
            <Switch>
              <Route
                exact
                path="/"
                component={Dashboard}
              />
              {routes.map(route => (
                <Route
                  path={route.path}
                  component={route.component}
                  key={route.path}
                  exact={route.exact}
                />
              ))}
              <Route path="/page403" component={Page403} />
              <Route path="/404" component={NotFoundPage} />
              <Route path="*" component={NotFoundPage} />
            </Switch>
          </IndexLayout>
        </Suspense>
      </ConnectedRouter>
    )
  }
}

export default Router

export const redirectTo = path => store.dispatch(push(path))
